export default __webpack_public_path__ + "static/media/clock.c6b876da.svg";